module.exports = __webpack_public_path__ + "static/top-abfb0b7c7490ee5c6042d8eccd7de839.png";